<template lang="pug">
.c-cropper-card
  v-card
    v-container
      v-layout(column)
        .pa-5.mx-auto(v-if="display"
          :style="{ width: '70%', 'max-width': '500px' }")
          cropper(
            ref="cropper"
            :src="display"
            v-bind="cropper")
        .text-xs-center(v-if="source && progress !== null")
          v-progress-circular(:value="progress"
            :size="100"
            :width="15"
            :rotate="-90"
            color="info") {{ progress }}%
        v-layout(v-else
          column)
          v-btn(@click="$refs.file.click()") 選擇圖片
            input.d-none(ref="file"
              type="file"
              accept="image/*"
              @change="uploadImage($event)")
          v-btn(v-show="display"
            @click="crop") 確認裁切
</template>

<script>
import { Cropper } from "vue-advanced-cropper";

export default {
  name: "CropperCard",
  components: {
    Cropper
  },
  props: {
    cropper: {
      type: Object,
      default: () => {
        {
          1 / 1;
        }
      }
    },
    source: {
      type: String,
      default: ""
    },
    progress: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      display: this.source
    };
  },
  watch: {
    source(n) {
      this.display = n;
    }
  },
  methods: {
    uploadImage(e) {
      const input = e.target;
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          this.display = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    crop() {
      const result = this.$refs.cropper.getResult();
      this.$emit("crop", result);

      return result;
    },
    reset() {
      this.source = null;
    }
  }
};
</script>
